module.exports = __webpack_public_path__ + "assets/img/img-placeholder-reel.91bc46b8.jpg";